import { useHistory, generatePath } from 'react-router-dom'
import { helpersUrl } from '../helpers'
import { useCallback } from 'react'

export function useHistoryPush() {
  const history = useHistory()
  return useCallback(
    (config: {
      route: string
      query?: Record<string, number | string | (number | string)[]>
      params?: Record<string, number | string>
    }) => {
      const url = generatePath(config.route, config.params)
      const path = helpersUrl.stringifyUrl({ url, query: config.query })
      history.push(path)
    },
    [history],
  )
}
